(async () => {
  const isWebpSupported = async () => {
    if (!self.createImageBitmap) return false;

    const webpData = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=';
    const blob = await fetch(webpData).then(r => r.blob());
    return createImageBitmap(blob).then(() => true, () => false);
  };
  if (!(await isWebpSupported())) return;


  const links = document.querySelector('#logo-slideshow-links').innerText.split('|||');
  let linkIndex = 0;
  const slideshow = document.querySelector('#logo-slideshow');

  const sleep = (time) => {
    return new Promise((resolve) => setTimeout(resolve, time));
  };

  const swap = async () => {
    const durations = {
      animation: 1000,
      pause: 2000
    };

    if (++linkIndex > links.length - 1) linkIndex = 0;

    const imageURL = links[linkIndex];
    slideshow.classList.add('simple-fade-swap');
    await sleep(durations.animation / 2);
    slideshow.src = imageURL;
    await sleep(durations.animation / 2);
    slideshow.classList.remove('simple-fade-swap');
    await sleep(durations.pause);

    await swap();
  };

  swap();
})();